













































import {defineComponent} from '@vue/composition-api';
import DynamicQuestionMixin from '@/tasks/mixins/dynamic-question';
import StembleLatex from '@/tasks/components/StembleLatex.vue';
import STextarea from '@/common/components/STextarea.vue';

export default defineComponent({
  name: 'UCIrvineELN3OIDataAnalysis4',
  components: {STextarea, StembleLatex},
  mixins: [DynamicQuestionMixin()],
  data() {
    return {
      inputs: {
        dataAnalysis4Link: null,
      },
      attachments: [] as File[],
      questions: [
        {
          text: 'Please paste a link to reference your data file or Google sheet',
          inputName: 'dataAnalysis4Link',
        },
      ],
    };
  },
});
